<template>
	<transition name="orderanimation">
		<div class="vx-col w-full mb-base" v-if="!order.hide">
			<vx-card :class="[
				isSelected() ? 'is-selected' : '',
				this.order.order.status === 5 ? 'is-shipping' : '',
				this.order.order.status === 8 ? 'is-shipping-failed' : '',
				this.order.order.status === 3 ? 'is-done' : '',
				this.order.order.type === 1 ? 'is-type-bol' : '',
				this.order.order.type === 2 ? 'is-type-lightspeed' : '',
				]"
			>
				<div class="vx-row">
					<div class="vx-col w-1/12 items-center">
						<vs-checkbox :checked="isSelected()" @change="select" class="inline-block" />
					</div>
					<div class="vx-col w-6/12">
						<div class="vx-row">
							<div class="vx-col w-4/12 ">
								<order-status :order="order" />
							</div>
							<div class="vx-col w-8/12">
								<orderid :order-id="order.order.type_id_visible" />

								<orderdatetime :order="order" />
							</div>
						</div>
					</div>

					<div class="vx-col w-5/12">
						<div class="vx-row">
							<optionmenu :order="this.order" :dymo-printer="this.dymoPrinter" />
						</div>
					</div>
				</div>

				<div class="vx-row">
					<div class="vx-col w-8/12 pl-10">
						<div class="vx-row">
							<div class="vx-col w-full mt-2 mb-1">
								<h4>Producten</h4>
							</div>
						</div>


						<product :dymo-printer="dymoPrinter" :order="order" :product="product" :index="index" :key="index" v-for="(product, index) in this.order.items" />

						<totals :order="order" :total-marge="totalMarge" :total-transaction-fee="this.order.order.order_commission" />
					</div>
					<div class="vx-col w-4/12">
						<div class="vx-row">

							<div class="vx-col w-full">
								<addresstabs :order="order" />
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</transition>
</template>

<script>
import product from '../product/product'
import Addresstabs from '../addresstabs/addresstabs';
import Orderid from './orderid';
import Orderdatetime from './orderdatetime';
import Totals from './totals';
import Optionmenu from './optionmenu/optionmenu';
import dymoPrinter from '../../../services/dymo/dymoPrinter';
import OrderStatus from '@/views/orders/components/status';

export default {
	components: {
		OrderStatus,
		Optionmenu,
		Totals,
		Orderdatetime,
		Orderid,
		Addresstabs,
		product,
	},
	props: {
		order: {
			type: Object,
			required: true,
		},
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
	data() {
		return {
			totalMarge: 0,
			checked: () => this.isSelected(),
			leaveAnimationDuration: 300,
		}
	},
	watch: {
		'order.done': {
			handler() {

			}
		}
	},
	mounted() {
		this.calculateTotalTransactionFee();
	},
	beforeDestroy() {
		const tooltips = document.getElementsByClassName('vs-tooltip');

		tooltips.forEach((tooltip) => {
			tooltip.style.display = 'none';
		});
	},
	methods: {
		calculateTotalTransactionFee() {
			this.totalMarge = (this.order.order.order_price.toFixed(2)) - (this.order.order.order_commission.toFixed(2));
		},
		isSelected() {
			return this.$parent.selectedOrderIds.includes(this.order.order.id);
		},
		select() {
			if (this.isSelected()) {
				this.$parent.selectedOrderIds = this.$parent.selectedOrderIds.filter(id => {
					return id !== this.order.order.id;
				});

			} else {
				this.$parent.selectedOrderIds.push(this.order.order.id);
			}
		}
	}
}
</script>

<style lang="scss">
.vx-card.is-type-bol {
	border-left: #0000A4 4px solid
}

.vx-card.is-type-lightspeed {
	border-left: #FF404C 4px solid
}

.vx-card.is-selected {
	background-color: rgba(var(--vs-primary), 0.05);
	-webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
	box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.vx-card.is-shipping {
	background-color: rgba(var(--vs-dark), 0.05);
	-webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-dark), 1) !important;
	box-shadow: 0 0 1px 0 rgba(var(--vs-dark), 1) !important;
}

.vx-card.is-shipping-failed {
	background-color: rgba(var(--vs-danger), 0.05);
	-webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-danger), 1) !important;
	box-shadow: 0 0 1px 0 rgba(var(--vs-danger), 1) !important;
}

.vx-card.is-done {
	background-color: rgba(var(--vs-success), 0.05);
	-webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-success), 1) !important;
	box-shadow: 0 0 1px 0 rgba(var(--vs-success), 1) !important;
}

.orderanimation-enter-active, .orderanimation-leave-active {
	transition: opacity .5s;
}

.orderanimation-enter, .orderanimation-leave-to {
	-webkit-animation: slide-out-right 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
	animation: slide-out-right 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}

@-webkit-keyframes slide-out-right {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0);
		opacity: 1;
	}
	100% {
		-webkit-transform: translateX(1000px);
		transform: translateX(1000px);
		opacity: 0;
	}
}

@keyframes slide-out-right {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0);
		opacity: 1;
	}
	100% {
		-webkit-transform: translateX(1000px);
		transform: translateX(1000px);
		opacity: 0;
	}
}


.button-alignment-end {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
	align-items: center;
}

[dir] .button-alignment-end > * {
	margin-top: 0.5rem;
}

[dir=ltr] .button-alignment-end > * {
	margin-right: 0.5rem;
}

[dir=rtl] .button-alignment-end > * {
	margin-left: 0.5rem;
}
</style>
